import React, { FC, useEffect, useRef } from 'react';
import { useParams } from 'react-router';

import DataGrid, { Column, Export, FilterRow, GroupPanel, HeaderFilter } from 'devextreme-react/data-grid';

import { nanoid } from '@reduxjs/toolkit';
import { Button, Template } from 'devextreme-react';
import { onExportExcel } from 'utils/exportExcel';

import { useLazyGetCashFlowHistoryQuery } from 'bus/cash';

export const CashFlowHistory: FC = () => {
  const { id } = useParams<{ id: string }>();

  const [getCashFlowHistory, { data }] = useLazyGetCashFlowHistoryQuery();

  let refGrid = useRef<DataGrid | null>(null);

  const refresh = () => {
    getCashFlowHistory({ id });
  };

  useEffect(() => {
    getCashFlowHistory({ id });
  }, [getCashFlowHistory, id]);

  return (
    <div className="d-flex mb-1 justify-end align-center">
      <DataGrid
        ref={refGrid}
        allowColumnReordering
        allowColumnResizing
        columnAutoWidth
        dataSource={data}
        showBorders
        loadPanel={{
          enabled: true,
          text: 'Загрузка',
        }}
        hoverStateEnabled
        onExporting={onExportExcel}
        onToolbarPreparing={(e) => {
          e.toolbarOptions?.items?.unshift({
            location: 'after',
            template: 'refresh',
          });
        }}
      >
        <Template name="refresh">
          <Button icon="refresh" onClick={refresh} />
        </Template>
        <GroupPanel visible />
        <HeaderFilter visible />
        <FilterRow visible />
        <Export enabled={false} />

        <Column dataField="groupDate" sortOrder="desc" caption="Дата" dataType="date" groupIndex={0} />
        <Column dataField="dateTime" sortOrder="desc" caption="Время" dataType="datetime" format="shortTime" />
        <Column dataField="fullName" caption="Сотрудник" />
        <Column dataField="type" caption="Тип" />
        <Column
          dataField="propertyChanges"
          caption="Новые значения"
          cellRender={({ data }) => (
            <div>
              {data.propertyChanges.map((item: any) => (
                <div className="d-flex mb-1" key={nanoid()}>
                  {item.key !== null ? (
                    <div className="mr-1" style={{ fontWeight: 'bold' }}>
                      {' '}
                      {`${item.key}:`}{' '}
                    </div>
                  ) : null}
                  {/* eslint-disable-next-line react/no-danger */}
                  <div dangerouslySetInnerHTML={{ __html: item.value }} />
                </div>
              ))}
            </div>
          )}
        />
      </DataGrid>
    </div>
  );
};
